module.exports = __webpack_public_path__ + "static/media/cooking.ca1f29ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooking.png
// module id = 1913
// module chunks = 0